import React, { useEffect } from 'react';
import axios from 'axios';
import { Modal, notification } from 'antd';
import { FormattedMessage } from 'react-intl';
import { hp } from "../../utils";


const Verification = (props) => {
    const { _auth, _utils } = props;

    useEffect(() => {
        const token = window.location.pathname.split('/')[3];
        const lang = _utils.lang;
        axios({
            method: 'GET',
            url: `${hp.getApiBaseUrl()}/verifications/${token}`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            const res = response.data;
            let user = _auth.user;
            const { authenticated } = _auth;
            if (res.statusCode === 200) {
                if (authenticated) {
                    user['status'] = 'ACTIVE';
                    hp.setCookie('user', JSON.stringify(user), 7);
                    window.location.assign(hp.getSuccessRedirect());
                } else {
                    window.location.assign(`/${lang || 'en'}/signin`);
                }
            } else {
                notification.error({ message: 'Unable to verify account' });
            }
        }).catch((err) => {
            Modal.info({
                title: <FormattedMessage id="Invitation.Invalid.Title" defaultMessage="Invalid invitation link" />,
                content: <FormattedMessage id="Invitation.Invalid.Description.Database" defaultMessage="This invitation was not found in our database" />,
                okText: <FormattedMessage id="Button.SignIn" defaultMessage="Sign in" />,
                onOk() {
                    window.location.assign(`/${lang || 'en'}/signin`);
                }
            });
        });
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <React.Fragment>

        </React.Fragment>
    );
};

export default Verification;